import angular from 'angular';
import download from './download';
import 'angular-file-saver';

/**
 * @ngdoc module
 * @name akamai.components.download
 * @description Provides users a simple interface to handle file downloads
 *
 * @param {string} uri Location where the file to be downloaded exists
 * @param {string} filename Name of the file being downloaded; file extension is optional.
 * If filename is not provided, downloaded file name will
 * be 'download' with appropriate file extension.
 * @returns {Object} Returns a promise which resolves when file downloads
 * successfully else rejects the promise for the developer to handle.
 *
 * @example index.js
 * function FileDownloadCtrl(download, $log) {
 *   let uri = '/example/foo.pdf';
 *   let filename = 'myFile.pdf';
 *
 *   function downloadFile() {
 *     download(uri, filename)
 *       .then(function() {
 *         $log.log('File downloaded');
 *       })
 *       .catch(function(error) {
 *         $log.log(error);
 *       });
 *   }
 * }
 */
export default angular.module('akamai.components.download', [
  'ngFileSaver'
])
  .factory('download', download);
